// @ts-nocheck
import React, {useState} from 'react'
import {Link, useLocation} from "react-router";
import styles from '../css/Result.module.css'
import TargetColorBox from '../../../TargetingV2/components/TargetColorBox'
import ChangeTargetDrop from './ChangeTargetDrop'
import apiFetch from '../../../../api/apiFetch'

function Result(props) {

    const location = useLocation()
    const [custom, setCustom] = useState(props.data)

    let name = null
    let address = null
    name = `${props.data.FIRST_NAME}${props.data.MIDDLE_NAME ? " " + props.data.MIDDLE_NAME : ""} ${props.data.LAST_NAME}`

    let address1 = props.data.ADDRESS1 !== null && props.data.ADDRESS1 !== undefined ? `${props.data.ADDRESS1}, ` : ""
    let address2 = props.data.ADDRESS2 !== null && props.data.ADDRESS2 !== undefined ? `${props.data.ADDRESS2}, ` : ""
    let city = props.data.CITY !== null && props.data.CITY !== undefined ? `${props.data.CITY}, ` : ""
    let state = props.data.STATE !== null && props.data.STATE !== undefined ? `${props.data.STATE} ` : ""
    let zip = props.data.ZIP5 !== null && props.data.ZIP5 !== undefined ? `${props.data.ZIP5}` : ""

    address = address1 + city + state + zip

    const updateCustomColumn = (temp) => {
        apiFetch(`/api/v2/targeting/update-custom-columns`, temp).then((data) => {
            for (let i = 0; i < data.length; i++) {
                let customColumns = JSON.parse(data[i].CUSTOM_COLUMNS)
                data[i] = {
                    ...data[i],
                    ...customColumns
                }
            }
        })
    }

    let cols = []
    for (let i = 0; i < Object.keys(props.config).length; i++) {
        if (Object.values(props.config)[i].show) {
            let value = Object.values(props.config)[i]
            if (value.title === "HEALTHCARE ORGANIZATION") {
                cols.push(
                    <td key={value.title} className={[styles.col, props.selected === i ? styles.selected : ""].join(" ")} style={{width: value.flex + '%'}}>
                        <div className={styles.info}>
                            {props.preview
                                ?
                                <div className={styles.name}>
                                    {props.data.NAME}
                                </div>
                                :
                                <Link to={`/hco/details/${props.data.ORG_ID}`} state={{ from: location.pathname }}>
                                    <div className={styles.name}>
                                        {props.data.NAME}
                                    </div>
                                </Link>
                            }
                            <div className={styles.address}>{address}</div>
                        </div>
                    </td>
                )
            }
            else if (value.col === "CURRENT_TARGET_VALUE") {
                cols.push(
                    <td className={[styles.col, styles.center, props.selected === i ? styles.selected : ""].join(' ')} key={value.title} style={{width: value.flex + '%'}}>
                        <div className={styles.flexcenter}>
                            <TargetColorBox small target={props.data[value.col]} />
                        </div>
                    </td>
                )
            }
            else if (value.col === "CHANGED_TARGET_VALUE") {
                cols.push(
                    <td className={[styles.col, styles.center, props.selected === i ? styles.selected : ""].join(' ')} key={value.title} style={{width: value.flex + '%'}}>
                        <div className={styles.flexcenter}>
                            <ChangeTargetDrop {...props}/>
                        </div>
                    </td>
                )
            }
            else {
                if (value.options === "LOV") {
                    let options = [<option key={"blank"} value={""}></option>]
                    let start = value.headerChecked ? 1 : 0
                    for (let j = start; j < value.LOV.length; j++) {
                        options.push(
                            <option key={value.LOV[j]} value={value.LOV[j]}>{value.LOV[j]}</option>
                        )
                    }
                    cols.push(
                        <td key={value.title} className={[styles.col, styles.center, props.selected ? styles.selected === i : ""].join(' ')} style={{width: value.flex + '%'}}>
                            <div className={styles.flexcenter}>
                                <select className={styles.setInput} value={custom[value.col]} onChange={(event) => {
                                        let temp = {
                                            mdmID: props.data.PROF_ID,
                                            key: value.col,
                                            value: event.target.value
                                        }
                                        updateCustomColumn(temp)
                                        setCustom(event.target.value)
                                    }} disabled={props.lock}>
                                    {options}
                                </select>
                            </div>
                        </td>
                    )
                }
                else if (value.options === "FreeText") {
                    cols.push(
                        <td key={value.title} className={[styles.col, styles.center, props.selected ? styles.selected === i : ""].join(' ')} style={{width: value.flex + '%'}}>
                            <div className={styles.flexcenter}>
                                <input className={styles.setInput} value={custom[value.col]}  onChange={(event) => {
                                    let temp = {
                                        mdmID: props.data.PROF_ID,
                                        key: value.col,
                                        value: event.target.value
                                    }
                                    updateCustomColumn(temp)
                                    setCustom(event.target.value)
                                }} disabled={props.lock}/>
                            </div>
                        </td>
                    )
                }
                else {
                    cols.push(<td className={[styles.col, styles.center, props.selected === i ? styles.selected : ""].join(' ')} key={value.title} style={{width: value.flex + '%'}}>
                        <div className={styles.flexcenter}>
                            {props.data[value.col]}
                        </div>
                    </td>)
                }

            }
        }
    }
    return (
        <tr className={styles.Result}>
            {cols}
        </tr>
    )
}

export default Result
